module.exports = __webpack_public_path__ + "img/lastmodified-icon.f314a8c0.svg";